// extracted by mini-css-extract-plugin
export default {"div":"Contactanos_div__IvXNO","button":"Contactanos_button__aLjsR","a":"Contactanos_a__NpUnO","icon":"Contactanos_icon__HVm1J"};